/**
 * Utility functions for environment detection
 */

/**
 * Checks if the application is running on localhost
 * @returns boolean indicating if running on localhost
 */
export function isLocalhost(): boolean {
	const hostname = window.location.hostname;
	return (
		hostname === "localhost" ||
		hostname === "127.0.0.1" ||
		hostname === "[::1]" ||
		hostname.startsWith("192.168.") ||
		hostname.startsWith("10.") ||
		hostname.startsWith("172.16.")
	);
}

/**
 * Checks if the application is running in development mode
 * @returns boolean indicating if running in development mode
 */
export function isDevelopment(): boolean {
	return import.meta.env.DEV;
}

/**
 * Checks if the application is running in production mode
 * @returns boolean indicating if running in production mode
 */
export function isProduction(): boolean {
	return import.meta.env.PROD;
}
